<template>
    <v-card>
        <v-toolbar fixed dark color="indigo" class="darken-4">
            <v-toolbar-title>
                Edit Passenger
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-form>
                <v-container>
                    <v-row>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.FirstName"
                                    label="First Name "
                                    required
                            ></v-text-field>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.LastName"
                                    label="Last Name"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-radio-group v-model="customerData.Gender" row label="Gender">
                                <v-radio label="Male" value="male"></v-radio>
                                <v-radio label="Female" value="female"></v-radio>
                                <v-radio label="Other" value="other"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-menu
                                    v-model="snackbar.dateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="customerData.DateOfBirth"
                                            label="Date of Birth"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="customerData.DateOfBirth">

                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.Nationality"
                                    label="Nationality"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-autocomplete
                                    v-model="customerData.Country"
                                    :items="countries"
                                    label="Country"
                                    clearable
                                    item-text="value"
                                    item-value="id"
                                    @change="getState"
                            ></v-autocomplete>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-autocomplete
                                    v-model="customerData.State"
                                    :items="state"
                                    label="State"
                                    clearable
                                    item-text="value"
                                    item-value="id"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="12"
                               sm="6" md="4">
                            <v-autocomplete
                                    v-model="customerData.AirID"
                                    :items="airList"
                                    label="Flight Number"
                                    clearable
                                    item-text="value"
                                    item-value="id"
                            ></v-autocomplete>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.FlightPNRNo"
                                    label="Flight PNR Number"
                                    required
                            ></v-text-field>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.TicketNumber"
                                    label="Ticket Number"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               sm="6" md="4">
                            <v-autocomplete v-model="customerData.FlightClass"
                                            :items="FlightClasses"
                                            label="Flight Class"
                                            item-text="value"
                                            item-value="value"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12"
                               sm="6" md="4">
                            <v-autocomplete v-model="customerData.PassengerType" :items="PassengerTypes"
                                            label="Passenger Type"></v-autocomplete>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-autocomplete
                                    v-model="customerData.PassengerServiceID"
                                    :items="Services"
                                    chips
                                    deletable-chips
                                    label="Services"
                                    clearable
                                    multiple
                                    item-text="value"
                                    item-value="id"
                            ></v-autocomplete>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-autocomplete
                                    v-model="customerData.packageID"
                                    :items="Report"
                                    chips
                                    deletable-chips
                                    label="Air Package"
                                    clearable
                                    multiple
                                    item-text="value"
                                    item-value="id"
                            ></v-autocomplete>
                        </v-col>


                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-autocomplete v-model="customerData.Destination"
                                            :items="Destinations"
                                            item-text="value"
                                            item-value="value"
                                            label="Destinations"></v-autocomplete>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-menu
                                    v-model="snackbar.dateMenu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="customerData.FlightDateTime"
                                            label="Flight Date"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="customerData.FlightDateTime">

                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.CitizenShipNumber"
                                    label="Citizenship Number"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.PassportNumber"
                                    label="Passport Number"
                                    required
                            ></v-text-field>
                        </v-col>

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.LicenseNumber"
                                    label="License Number "
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.OtherID"
                                    label="Other Id "
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.Document"
                                    label="Document"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-switch
                                    class="col-sm-6 col-md-4"
                                    v-model="customerData.IsVerifiedDocument"
                                    label="Is Verified Document?"
                                    clearable
                            ></v-switch>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-text-field
                                    v-model="customerData.IssuedBy"
                                    label="Issued By"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-menu
                                    v-model="snackbar.dateMenu3"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="customerData.IssuedDate"
                                            label="Issued Date"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="customerData.IssuedDate">

                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">Cancel</v-btn>
            <v-btn class="custom-save-button" @click="formSubmit">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";

    export default {
        name: "CompanyCustomerEditForm",
        data() {
            return {
                customerData: {},
                customerFormData: [],
                message: {
                    status: true,
                    text: 'true',
                },
                snackbar: {
                    dateMenu: false,
                    dateMenu2: false,
                    dateMenu3: false,
                },
                countries: [],
                state: [],
                airList: [],
                Destinations: [],
                Services: [],
                PassengerTypes: ['Adult', 'Child', 'Old'],
                FlightClasses: [],
                Issuer: ['E-Sewa'],
                Report: [],

            }
        },
        props: ['editItemIndex']
        ,
        computed: {},
        methods: {
            dialogueClose() {
                this.customerData = {}
                this.customerFormData = []
                this.$emit('dialogueClose')
            },
            formSubmit() {
                axios.post('Company/UpdatePassengerInformationAsync', this.customerData)
                    .then(() => {
                        this.message.status = true
                        this.message.text = 'Passenger is Successfully Updated'
                        this.$emit('formResponse', this.message)
                        this.dialogueClose()
                    })
                    .catch(() => {
                        this.message.status = false
                        this.message.text = 'Error Updating Service, Please Contact Admin'
                        this.$emit('formResponse', this.message)
                        this.dialogueClose()
                    })
            },
            async getState(val) {
                const stateList = await axios.get('Shared/StateListByCountryCode?CountryCode=' + val);
                this.state = stateList.data
            },
            async formData() {
                const countryList = await axios.get("Shared/CountryList");
                this.countries = countryList.data;
                const airList = await axios.get("Company/DDLSectionsListAsync");
                this.airList = airList.data
                const Destinations = await axios.get("Company/DDLCompanyByIDAsync");
                this.Destinations = Destinations.data
                const Services = await axios.get("Company/DDLPassengerServiceListAsync");
                this.Services = Services.data

                const FlightClasses = await axios.get("StaticValues/DDLCommonStaticValuesListAsync/101");//DDLStaticValuesListAsync
                this.FlightClasses = FlightClasses.data

                const Package = await axios.get('Company/DDLAirPackageListAsync');
                this.Report = Package.data

            },
            async getEditData() {
                const CustomerData = await axios.get('Company/GetPassengerInformationByIDAsync/' + this.editItemIndex)
                this.getState(CustomerData.data.country)
                console.log(CustomerData)
                this.fillFormData(CustomerData.data)
            },
            fillFormData(data) {
                this.customerData.packageID = data.packageID
                this.customerData.PassengerInformationID = data.passengerInformationID
                this.customerData.AirID = data.airID.toString()
                this.customerData.PassengerInformationID = data.passengerInformationID
                this.customerData.BranchID = data.branchID
                this.customerData.FirstName = data.firstName
                this.customerData.LastName = data.lastName
                this.customerData.Gender = data.gender
                this.customerData.Age = data.age
                this.customerData.Nationality = data.nationality
                this.customerData.Country = data.country
                this.customerData.State = data.state
                this.customerData.PassengerType = data.passengerType
                this.customerData.FlightPNRNo = data.flightPNRNo
                this.customerData.TicketNumber = data.ticketNumber
                this.customerData.FlightClass = data.flightClass
                this.customerData.IssuedBy = data.issuedBy
                this.customerData.IssuedDate = data.issuedDate
                this.customerData.PassengerServiceID = data.passengerServiceID
                console.log(data);
                this.customerData.Destination = data.destination
                console.log('Destination',this.customerData.Destination)
                this.customerData.FlightNumber = data.flightNumber
                this.customerData.FlightDateTime = data.flightDateTime
                this.customerData.FreeBaggage = data.freeBaggage
                this.customerData.CitizenShipNumber = data.citizenShipNumber
                this.customerData.PassportNumber = data.passportNumber
                this.customerData.LicenseNumber = data.licenseNumber
                this.customerData.OtherID = data.otherID
                this.customerData.Document = data.document
                this.customerData.DateOfBirth = data.dateOfBirth
                this.customerData.IsVerifiedDocument = data.isVerifiedDocument
            }
        },
        mounted() {
            this.formData();
            this.getEditData()
        },
    }
</script>

<style scoped>

</style>
